import React from 'react';
export function Header() {
  return <header className="bg-white py-5 px-5 flex justify-center items-center shadow-[0_1px_4px_rgba(0,0,0,0.04)] relative z-10" data-id="element-13">
      <img src="https://cdn.magicpatterns.com/uploads/4Rp1r76RBY9nF2ZxncRocz/logovertical.png" alt="Aurora" className="h-14 md:h-16 object-contain" data-id="element-14" />
    </header>;
}